import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  constructor(private http:HttpClient) { }

  /**
   * Posts request nonce
   * @param walletAddress
   * @returns
   */
  postRequestNonce(walletAddress: any) {
    return this.http.post(`${environment.API_BASE_URL}auth/nonce`, { "walletAddress": walletAddress })
  }

  /**
   * Posts authenticate
   * @param data
   * @returns
   */
  postAuthenticate(data: any) {
    return this.http.post(`${environment.API_BASE_URL}auth/authenticate`, data)
  }
}
